import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectGeneralAuth } from '../../../store/auth/auth.selectors';
import {switchMap, take} from 'rxjs';
import { AuthState } from '../../../core/models/auth';

export const loggerInterceptor: HttpInterceptorFn = (req, next) => {
  const store = inject(Store);
  const excludedUrls = ['/login', '/sign-up'];

  // Esclude alcune rotte
  if (excludedUrls.some(url => req.url.includes(url))) {
    return next(req);
  }

  return store.select(selectGeneralAuth).pipe(
    take(1), // 🔒fix bug richieste ripetute FIXME è errato gestire lo stato qui...
    switchMap((auth: AuthState | null) => {
      const token =
        auth?.authResponse?.accessToken ||
        auth?.firebaseResponse?._tokenResponse.idToken || null;

      const authReq = token
        ? req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        })
        : req;

      return next(authReq);
    })
  );
};
